import "../css/index.less";
import { Tools } from "../../../../common/func/tools/index";

class Rating {
  static getRateAvg(product_id) {
    $.ajax({
      url: "https://backend.1010diy.com:8086/web/reviewAvg?product_id=" + product_id,
      success: function (rt) {
        let data = JSON.parse(rt);
        let ratingValue = parseFloat(data).toFixed(1);
        $(".star-score").html(ratingValue);
      },
      error: function (rt) {
        console.log(rt);
      },
    });
  }
  static addStar(rate_value, product_id) {
    $.ajax({
      url: "https://backend.1010diy.com:8086/web/addStar/",
      type: "post",
      data: {
        product_id: product_id,
        value: rate_value,
      },
      success: function (rt) {
        let data = JSON.parse(rt);
        if (data.status == "ok") {
        }
      },
      error: function (rt) {
        console.log(rt);
      },
    });
  }
  static reviews(product_id) {
    $.ajax({
      url: "https://backend.1010diy.com:8086/web/reviewTotal?product_id=" + product_id,
      success: function (rt) {
        let data = JSON.parse(rt);
        if (data / 1000 > 1) {
          if (data / 10000 > 1) {
            data = (data / 10000).toFixed(1) + "M";
          } else {
            data = (data / 1000).toFixed(1) + "K";
          }
        }
        $(".star-count").html(data);
      },
    });
  }
}
$(function () {
  $.fn.raty.defaults.path = "https://okmusi.com/asset/common/images/star/";

  $("#star-list").raty({
    click: function (score, evt) {
      console.log(score, evt);
      Rating.addStar(score, 898);
      Rating.getRateAvg(898);
      Rating.reviews(898);
      $(this).closest(".star-list").animate({ left: "0px", opacity: 0 }, 500);
    },
  });
  $("#star-list").find("img").attr({
    width: 20,
    height: 20,
  });

  var isFistScroll = true;
  $("a.part").click(function () {
    var linkID = $(this).attr("href");
    var id = linkID.substring(1, linkID.length);
    if (isFistScroll) {
      $("html, body").animate({ scrollTop: $("#" + id).offset().top - 64 }, 0);
      setTimeout(function () {
        $("html, body").animate({ scrollTop: $("#" + id).offset().top - 64 }, 0);
      }, 100);
      isFistScroll = false;
    } else {
      $("html, body").animate({ scrollTop: $("#" + id).offset().top - 64 }, 0);
    }
    return false;
  });

  $(".faq .f-li h3").on("click", function () {
    let active = $(this).parent();
    if (!active.hasClass("active")) {
      $(".faq .f-li p").slideUp();
      $(".faq .f-li").removeClass("active");
      $(this).siblings("p").slideDown();
      active.addClass("active");
    } else {
      $(this).siblings("p").slideUp();
      active.removeClass("active");
    }
  });
  let $productDownload = $('[data-handle="productDownload"]'),
    isFirstScroll = true;
  if ((Tools.isPC() && Tools.isMac()) || Tools.isIOS()) {
    $productDownload.attr("data-type", "1").find(".text2").text("for macOS 10.15+");
    $productDownload.attr("href", "/pro-audio-toolkits/download-mac/");
  } else if (Tools.isAndroid()) {
    $productDownload.attr("data-type", "2").find(".text2").text("for Android");
    $productDownload.attr("href", "/mp3-downloader/download-android/");
  }

  $(document).on("click", 'div[data-handle="starBtn"]', function () {
    let slLeft = $(".star-list").css("left"),
      leftParam = Tools.isPC() ? "42px" : "72px";
    if (slLeft == "0px") {
      $(".star-list").animate({ left: leftParam, opacity: 1 }, 500);
    } else {
      $(".star-list").animate({ left: "0px", opacity: 0 }, 500);
    }
  });
});

(function () {
  let globalScrollOnce = true;
  $(window).on("scroll", function () {
    let scrollTop = $(this).scrollTop();
    if (scrollTop > 0 && globalScrollOnce) {
      Rating.getRateAvg(898);
      Rating.reviews(898);
      globalScrollOnce = false;
    }
  });
})();
const initChannelLink = () => {
  let $close = $('.channel-link .channel-link-close')
  let $channel = $('.channel-link')
  $close.on('click', (e) => {
      e.preventDefault();
      $channel.hide()
  })
}
const initEvent = () => {
  const $upload = $('[data-handle="upload"]')
  const $productBox = $('[data-handle="product-box"]')
  const $close = $('[data-handle="product-box-close"]')
  $upload.on('click', () => {
    $productBox.css("display", "flex")
  })
  $close.on('click', () => {
    $productBox.hide()
  })
}
$(() => {
  initChannelLink()
  initEvent()
})